export default __webpack_public_path__ + "static/media/guest-repeat-blue.2253d8d8.svg";